<template>
    <div class="d-inline">
        <div class="round-btn btn-remove sl-button-remove"
             v-b-tooltip.hover :title="hoverText"
             @click="onButtonClick">
            <b-icon :icon="icon" font-scale="1.2"></b-icon>
        </div>
        <b-overlay :show="busy" no-wrap :fixed="true" :z-index="1135">
            <template v-slot:overlay>
                <spinner-component v-if="isLoading"></spinner-component>
                <div v-else
                     ref="dialog"
                     class="confirm-dialog text-center p-4 border border-info rounded shadow">
                    <p>
                        <strong id="form-confirm-label">{{ deleteMessage }}</strong>
                    </p>
                    <div class="">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                            Abbrechen
                        </b-button>
                        <b-button variant="outline-success" @click="onOK">Ja, Buchung löschen
                        </b-button>
                    </div>
                </div>
            </template>
        </b-overlay>
    </div>
</template>
<script>

import SpinnerComponent                                   from "../base/SpinnerComponent";
import {cancelRecentlyMadeOrders, removeFoodOrderRequest} from "../../api/food-order";
import {mapActions}                                       from "vuex";

export default {
    name:       "RemoveOrderComponent",
    components: {
        'spinner-component': SpinnerComponent
    },
    data() {
        return {
            busy:      false,
            isLoading: false
        }
    },
    props:   {
        item:          Object,
        icon:          {
            type:    String,
            default: 'trash-fill'
        },
        type:          {
            type:    String,
            default: 'delete'
        },
        hoverText:     {
            type:    String,
            default: 'Reservierung stornieren'
        },
        deleteMessage: {
            type:    String,
            default: 'Möchten Sie diese Buchung wirklich\n' +
                         '                            rückgängig machen? Sie wird dann aus dem System gelöscht und der Betrag\n' +
                         '                            wird dem Kind zurück auf sein Guthaben gebucht.'
        },
    },
    methods: {
        ...mapActions(['setSelectedConsumer']),
        onButtonClick() {
            this.busy = true;
        },
        onCancel() {
            this.busy = false
        },
        cancelPickUp: async function () {
            const self     = this;
            this.isLoading = true;

            try {
                await cancelRecentlyMadeOrders({orderIds: [self.item.foodorder_id]}).then(() => {
                    self.busy = false
                }).then(() => {
                    this.$emit('reloadOrders');
                    this.$store.dispatch('setLimitOrders');
                });

            } catch (e) {
                alert('An error occurred\r\nPlease refresh the page');
            }

            self.isLoading = false;
        },
        deleteItem:   async function () {
            const self     = this;
            this.isLoading = true;

            try {
                await removeFoodOrderRequest(self.item.foodorder_id).then(() => {
                    self.busy = false
                }).then(() => {
                    this.$emit('reloadOrders');
                    this.$store.dispatch('setLimitOrders');
                });

            } catch (e) {
                alert('An error occurred\r\nPlease refresh the page');
            }

            self.isLoading = false;
        },
        onOK() {
            if (this.type === 'cancel') {
                this.cancelPickUp();
            } else {
                this.deleteItem();
            }

        }
    }
}
</script>

<style scoped>
/* The b-overlay backdrop only dims the page; without its own background the
   dialog let the table underneath read straight through it. */
.confirm-dialog {
    background-color: #fff;
    max-width: 520px;
}
</style>
